import { useEffect, useState } from "react";
import { CartConfigInterface } from "../CartTypes";
import styles from "./CartDrawer.module.css";
import Countdown from "react-countdown";
import { CUSTOM_HTML_POS_OPT, CustomHtmlPosTypes, getPixelsForCart } from "../../Bundles/constants";

export const CustomHTMLWrapper = ({
    cartConfig,
    currentPosition = "",
}: {
    cartConfig: CartConfigInterface;
    currentPosition: CustomHtmlPosTypes | "";
}) => {
    return cartConfig?.cart_settings?.custom_html_text?.trim()?.length &&
        cartConfig?.cart_settings?.custom_html_position == currentPosition ? (
        <div
            className={styles.customHtmlBox}
            dangerouslySetInnerHTML={{ __html: cartConfig?.cart_settings?.custom_html_text }}
        ></div>
    ) : (
        <></>
    );
};

const DigitBlock = ({ digits }: { digits: number }) => {
    return (
        <div>
            {`${digits}`
                .padStart(2, "0")
                .split("")
                .map((digit, idx) => (
                    <span key={idx} className={styles.digitBlock}>
                        {digit}
                    </span>
                ))}
        </div>
    );
};

const AnnouncementComponent = ({
    cartConfig,
    standAlone = false,
}: {
    cartConfig: CartConfigInterface;
    standAlone?: boolean;
}) => {
    const [renderAnnouncement, setRenderAnnouncement] = useState(true);
    const [endTime, setEndTime] = useState<number | null>(null);

    const shop = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    const timerKey = `${shop}_announcement_countdown_end`;
    const statusKey = `${shop}_announcement_countdown_status`;
    const durationKey = `${shop}_announcement_duration`;

    useEffect(() => {
        const hoursInMs = cartConfig?.announcement.countdown_time_hh * 60 * 60 * 1000;
        const minutesInMs = cartConfig?.announcement.countdown_time_mm * 60 * 1000;
        const duration = hoursInMs + minutesInMs;

        const storedStatus = sessionStorage.getItem(statusKey);
        const storedDuration = sessionStorage.getItem(durationKey);
        const prevDuration = storedDuration ? Number(storedDuration) : null;

        if (storedStatus === "finished") {
            setRenderAnnouncement(false);
            return;
        }

        if (prevDuration !== duration) {
            sessionStorage.removeItem(timerKey);
            sessionStorage.removeItem(statusKey);
        }

        const storedEndTime = sessionStorage.getItem(timerKey);

        if (storedEndTime && Number(storedEndTime) > Date.now()) {
            setEndTime(Number(storedEndTime));
        } else {
            const newEnd = Date.now() + duration;
            sessionStorage.setItem(timerKey, newEnd.toString());
            sessionStorage.setItem(durationKey, duration.toString());
            setEndTime(newEnd);
        }
    }, []);

    const renderer = ({
        minutes,
        seconds,
        completed,
    }: {
        hours: number;
        minutes: number;
        seconds: number;
        completed: boolean;
    }) => {
        if (completed) {
            setRenderAnnouncement(false);
            sessionStorage.removeItem(timerKey);
            sessionStorage.setItem(statusKey, "finished");
        }
        return (
            <span
                className={styles.announcementTimerWrapper}
                style={{
                    color: cartConfig?.announcement_design?.countdown_timer_color,
                    fontSize: cartConfig?.announcement_design?.countdown_timer_size,
                }}
            >
                <DigitBlock digits={minutes} />:<DigitBlock digits={seconds} />
            </span>
        );
    };

    if (!renderAnnouncement || !endTime) return null;

    return renderAnnouncement ? (
        <>
            <CustomHTMLWrapper cartConfig={cartConfig} currentPosition={CUSTOM_HTML_POS_OPT.ABOVE_ANNOUNCEMENT} />
            <div
                className={styles.announcementWrapper}
                style={{
                    background: cartConfig?.announcement_design?.message_bg_color,
                    color: cartConfig?.announcement_design?.message_text_color,
                    fontSize: cartConfig?.announcement_design?.message_text_size,
                    fontWeight: cartConfig?.announcement_design?.message_text_style?.split(" ")[0],
                    fontStyle: cartConfig?.announcement_design?.message_text_style?.split(" ")[1],
                    minHeight: +getPixelsForCart(cartConfig?.announcement?.announcement_hight, "number") - 10 + "px",
                }}
            >
                {cartConfig?.announcement?.announcement_message_1?.split("{timer}")[0]}
                {cartConfig?.announcement?.announcement_message_1?.includes("{timer}") && (
                    <span
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: cartConfig?.announcement_design?.countdown_timer_size + 30,
                        }}
                    >
                        <Countdown date={endTime} renderer={renderer} />
                    </span>
                )}
                {cartConfig?.announcement?.announcement_message_1?.split("{timer}")[1] ?? ""}
            </div>
        </>
    ) : (
        <></>
    );
};

export default AnnouncementComponent;
